module.exports = __webpack_public_path__ + "static/media/new-veg-icon.33030172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-veg-icon.png
// module id = 597
// module chunks = 11